import React from 'react';
import * as RadixCheckbox from '@radix-ui/react-checkbox';
import { Icon } from '../icon';
import { cn } from '@ui/lib';

const Root = (props: RadixCheckbox.CheckboxProps) => (
  <RadixCheckbox.Root
    {...props}
    className={cn(
      'flex size-lg justify-center rounded-sm border-xxs border-line',
      props.className,
    )}
  />
);

const Indicator = (props: RadixCheckbox.CheckboxIndicatorProps) => (
  <RadixCheckbox.Indicator
    {...props}
    className="flex size-md justify-center self-center rounded-sm bg-primary p-xxs"
  >
    <Icon className="text-white-1000" fileName="ic_check_filled" size="md" />
  </RadixCheckbox.Indicator>
);

export { Root, Indicator };
